export default "__VITE_ASSET__0552891c__"